"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processLayer = exports.processLayers = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
/*
 * each key of layer available_attributes looks like
 * {
 *    'Attribute Name': {
 *        config_bit1: ...,
 *        config_bit2: ...,
 *        ....
 *    }
 * }
 * We need to camel case the config, but not the 'Attribute Name'
 */
function processLayers(resp) {
    resp.data = (0, camelcase_keys_1.default)(resp.data, { deep: true, stopPaths: ['result.layers'] });
    resp.data.result.layers = resp.data.result.layers.map((layer) => {
        // we're assigning to function argument and eslint will like it!
        // eslint-disable-next-line
        layer = (0, camelcase_keys_1.default)(layer, {
            deep: true,
            stopPaths: ['availableAttributes', 'available_attributes', 'style.symbols'],
        });
        layer.availableAttributes = (0, lodash_mapvalues_1.default)(layer.availableAttributes, val => (0, camelcase_keys_1.default)(val));
        layer.style.symbols = (0, lodash_mapvalues_1.default)(layer.style.symbols, val => (0, camelcase_keys_1.default)(val));
        return layer;
    });
}
exports.processLayers = processLayers;
function processLayer(resp) {
    var _a;
    resp.data = (0, camelcase_keys_1.default)(resp.data, { deep: true, stopPaths: ['result'] });
    const layer = resp.data.result;
    resp.data.result = (0, camelcase_keys_1.default)(layer, {
        deep: true,
        stopPaths: ['availableAttributes', 'available_attributes', 'style.symbols'],
    });
    resp.data.result.availableAttributes = (0, lodash_mapvalues_1.default)((_a = layer.available_attributes) !== null && _a !== void 0 ? _a : layer.availableAttributes, val => (0, camelcase_keys_1.default)(val));
    resp.data.result.style.symbols = (0, lodash_mapvalues_1.default)(layer.style.symbols, val => (0, camelcase_keys_1.default)(val));
}
exports.processLayer = processLayer;
//# sourceMappingURL=layers.js.map